import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouPicture from 'components/tools/fou-picture/'
import LoadAnimation from 'components/animations/loading'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import ErrorIcon from 'components/icons/error/'
import OkIcon from 'components/icons/ok/'
import WarningIcon from 'components/icons/warning/'
import TrashIcon from 'components/icons/trash/'
import Draggable from 'vuedraggable'
import { TimeoutUtil } from 'src/utils/helper/timer'
import { DraggableObject } from 'src/utils/objects/draggable'
import Methods from './results.methods.js'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import Validator from 'src/pages/submissions/components/validator/'
import {mapActions, mapGetters, mapState} from 'vuex'
import CustomerMessage from './../customerMessage'
import smartSorting from './../smart-sorting'
import Externalsku from './../externalsku'
import { SubmissionObject , errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import BinaryValidationIcons from './../binaryValidationIcons'
import Misc from 'src/utils/helper/misc'
import WarningTriangleIcon from 'components/icons/warning-triangle/'
import { useForm } from 'vee-validate'
import TextField from 'src/components/form/text-field/index.vue'
import StyleTextBox from './../style-textbox'
import { isEmpty } from 'lodash'
import { MdTypography } from '@antiqua-dls/vue-components'

export default {
  name: 'results',

  components: {
    FouModal,
    FouContainer,
    FouGroup,
    FouPicture,
    ...FouGrid,
    LoadAnimation,
    MyfontsShortCircleIcon,
    ErrorIcon,
    OkIcon,
    WarningIcon,
    TrashIcon,
    Draggable,
    Validator,
    Externalsku,
    CustomerMessage,
    BinaryValidationIcons,
    WarningTriangleIcon,
    smartSorting,
    TextField,
    StyleTextBox,
    MdTypography
  },

  setup() {
    const { errors, setErrors, validate } = useForm()
    return {
      errors,
      setErrors,
      validate
    }
  },

  data() {
    return {
      results: {
        items: [],
        timer: TimeoutUtil()
      },
      isDragDropDisable: false,
      family: {
        name: null,
        editing: false,
        uniqueName: null
      },
      bannedWordForStyle: false,
      isFontsValidated: false,
      fouDraggable: DraggableObject(this),
      unsubscribe: null,
      binaries2compare: {},
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      fontURI: process.env.MY_FONTS_URL,
      stepsHasErrorsUrl: this.$route.params.stepsHasErrorsUrl,
      ...SubmissionObject,
      certify: false,
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      isErrorOnFont: false,
      removeFontId: null,
      removePriceId: null,
      styleNames: [],
      familyIntialValue: null
    }
  },

  watch: {
    commitmentBoxCheck: {
      handler(newVal) {
        const { items: newItems, checks } = newVal;
        const anyCheckFalse = checks.some(check => !check);
        if (this.submission.status === 'in_correction') {
          return;
        }
        if (newItems.length > 0 && anyCheckFalse) {
          submissionErrors.value.push({'Check your font name upload': 'The commitment box field is required.'});
        } else {
          submissionErrors.value = submissionErrors.value.filter(error => !error.hasOwnProperty('Check your font name upload'));
        }
      },
      immediate: true,
    },
    isErrorOnFont: {
      handler(newVal) {
        this.handleFontValidationError(newVal)
      },
      immediate: true
    },
    errors: {
      handler(newVal) {
        if (isEmpty(this.results.items)) {
          submissionErrors.value = []
        }
        if (!isEmpty(newVal)) {
          this.handleErrorsForValidation(newVal)
        }
      },
      immediate: true
    },
    check1: {
      handler(newVal) {
        if (isEmpty(this.results.items)) {
          submissionErrors.value = []
        }
        if (newVal && this.check1 && this.check2 && this.check3 && this.check4) {
          const certifyErrors = submissionErrors.value.filter(
            error => !error.hasOwnProperty('Check your font name upload')
          )
          submissionErrors.value = certifyErrors
        }
      },
      immediate: true
    },
    check2: {
      handler(newVal) {
        if (isEmpty(this.results.items)) {
          submissionErrors.value = []
        }
        if (newVal && this.check1 && this.check2 && this.check3 && this.check4) {
          const certifyErrors = submissionErrors.value.filter(
            error => !error.hasOwnProperty('Check your font name upload')
          )
          submissionErrors.value = certifyErrors
        }
      },
      immediate: true
    },
    check3: {
      handler(newVal) {
        if (isEmpty(this.results.items)) {
          submissionErrors.value = []
        }
        if (newVal && this.check1 && this.check2 && this.check3 && this.check4) {
          const certifyErrors = submissionErrors.value.filter(
            error => !error.hasOwnProperty('Check your font name upload')
          )
          submissionErrors.value = certifyErrors
        }
      },
      immediate: true
    },
    check4: {
      handler(newVal) {
        if (isEmpty(this.results.items)) {
          submissionErrors.value = []
        }
        if (newVal && this.check1 && this.check2 && this.check3 && this.check4) {
          const certifyErrors = submissionErrors.value.filter(
            error => !error.hasOwnProperty('Check your font name upload')
          )
          submissionErrors.value = certifyErrors
        }
      },
      immediate: true
    },
    submissionLimitError (newValue, oldValue) {
      if (isEmpty(this.results.items)) {
        submissionErrors.value = []
      }
      if (newValue) {
        const certifyErrors = submissionErrors.value.filter(
          error => !error.hasOwnProperty('Check your font name upload')
        )
        submissionErrors.value = certifyErrors
      }
    },
    filesWithFalseAvStatus: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'Malware detected upload'));
        }
      }
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('binaries', ['getBinaryFontRenderSrc', 'getUploadedFonts', 'getScanStatus']),
    ...mapState('binaries', {
      filesWithFalseAvStatus: ['filesWithFalseAvStatus']
    }),
    ...mapGetters('auth', ['hasRole', 'user']),
    validateCustomerMsg () {
      if (this.submission.status === 'in_correction' && this.submission.isLive) {
        return 'required|script_tag_validate'
      }
    },
    commitmentBoxCheck() {
      return {
        items: this.results?.items,
        checks: [this.check1, this.check2, this.check3, this.check4],
      };
    },
    styleNameErrors() {
      const errors = []
      for (let key of Object.keys(this.errors)) {
        if (key.includes('style name')) {
          errors.push(this.errors[key])
        }
      }
      return errors
    }
  },

  methods: {
    ...mapActions('overlay', ['hide', 'show']),
    ...Methods,
    ...SubmissionMethods,
    ...Misc,
    bannedWordForStyleName(valueIs) {
      this.bannedWordForStyle = valueIs
    },
    draggableStart() {
      this.fouDraggable.start()
    },
    draggableEnd() {
      this.fouDraggable.end()
    },
    getCustomError (lang) {
      if (lang === 'en') {
        return {
          custom: {
            'commitment_box': {
              required: 'You must check all boxes to proceed. Please read all information carefully.'
            }
          }
        }
      }
      return {}
    },
    handleFontValidationError(isError) {
      if (isError) {
        this.setErrors({
          'font validation upload': this.$t('pages.submissions.components.validator.general_message')
        })
      } else {
        submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'font validation upload'))
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
    },
    handleErrorsForValidation(newVal) {
      for (const key in newVal) {
        submissionErrors.value.push({ [key]: newVal[key] })
      }
      if (this.removeFontId) {
        this.removeErrorFromSubmissionErrors(this.results.items)
      }
      if (!this.isErrorOnFont) {
        submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'font validation upload'))
      }
      if (this.check1 && this.check2 && this.check3 && this.check4) {
        submissionErrors.value = submissionErrors.value.filter(
          error => !error.hasOwnProperty('Check your font name upload')
        )
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
      this.removeFontId = null
      this.removePriceId = null
    }
  },
  created() {
    if (this.submissionLimitError) {
      this.check1 = true
      this.check2 = true
      this.check3 = true
      this.check4 = true
    }
    this.addReadyState()
    this.setSubmissionBuild({
      before: this.buildSubmission
    })
    this.resultsFamilyInit(true)
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },
  
  beforeUnmount() {
    this.results.timer.clear()
    this.unsubscribe()
    this.$events?.$off('trigger:validate')
    submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'Check your font name upload'))
    this.$store.commit('binaries/setScanStatus', '');
  },
}
